import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { EyeOff, X } from "lucide-react";
import TextoComGlossario from "./TextoComGlossario";

export default function DetalhePropostasModal({ candidato, detalhe, aberto, aoFechar }) {
  useEffect(() => {
    if (!aberto) return undefined;

    function fecharComEscape(event) {
      if (event.key === "Escape") aoFechar();
    }

    document.addEventListener("keydown", fecharComEscape);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", fecharComEscape);
      document.body.style.overflow = "";
    };
  }, [aberto, aoFechar]);

  if (!aberto || !detalhe) return null;

  const grupos = [
    { chave: "aprovadas", titulo: "Propostas que você aprovou", propostas: detalhe.aprovadas, tipo: "aprovadas", verbo: "aprovada" },
    { chave: "recusadas", titulo: "Propostas que você recusou", propostas: detalhe.recusadas, tipo: "recusadas", verbo: "recusada" },
  ];

  return createPortal(
    <div className="teste-cego-modal" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) aoFechar(); }}>
      <section className="teste-cego-modal__janela" role="dialog" aria-modal="true" aria-labelledby="titulo-modal-propostas">
        <header className="teste-cego-modal__cabecalho">
          <div>
            <p className="teste-cego__legenda"><EyeOff size={14} /> Leitura do seu alinhamento</p>
            <h2 id="titulo-modal-propostas" className="teste-cego__titulo-modal">{candidato}</h2>
            <p className="teste-cego-modal__descricao">As propostas abaixo foram reveladas após suas respostas. Este detalhamento mostra apenas suas escolhas neste teste.</p>
          </div>
          <button type="button" className="teste-cego__botao-neutro focus-ring" onClick={aoFechar}><X size={15} /> Fechar</button>
        </header>
        <div className="teste-cego-modal__conteudo">
          {grupos.map((grupo) => (
            <section className="teste-cego-modal__grupo" key={grupo.chave}>
              <div className="teste-cego-modal__grupo-titulo">
                <span className={`teste-cego-modal__contador teste-cego-modal__contador--${grupo.tipo}`}>{grupo.propostas.length}</span>
                <h3>{grupo.titulo}</h3>
              </div>
              <div className="teste-cego-modal__lista">
                {grupo.propostas.length > 0 ? grupo.propostas.map((proposta, indice) => (
                  <article className={`teste-cego-modal__proposta teste-cego-modal__proposta--${grupo.tipo}`} key={proposta.id}>
                    <p><span /> Proposta {String(indice + 1).padStart(2, "0")}</p>
                    <div><TextoComGlossario>{proposta.text}</TextoComGlossario></div>
                  </article>
                )) : <p className="teste-cego-modal__vazio">Nenhuma proposta deste candidato foi {grupo.verbo}.</p>}
              </div>
            </section>
          ))}
        </div>
      </section>
    </div>,
    document.body,
  );
}
